<template>
  <div class="page-add">
    <div class="add-title">
      {{ addTitle }}
    </div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      :rules="rules"
      label-width="130px"
      class="form"
      size="small"
      :disabled="true"
    >
      <el-row>
        <el-col>
          <el-form-item class="scale" label=" APP是否展示：" required>
            <el-radio-group v-model="ruleForm.isApp">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label=" WEB是否展示："
            required
          >
            <el-radio-group v-model="ruleForm.isWeb">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label=" 小程序是否展示："
            required
          >
            <el-radio-group v-model="ruleForm.isApplet">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="PC端是否展示："
            required
          >
            <el-radio-group v-model="ruleForm.isPc">
              <el-radio
                v-for="item in publicData"
                :key="item.paramKey"
                :label="Number(item.paramKey)"
                >{{ item.paramValue }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="标题：" prop="bannerTitle">
            <el-input
              placeholder="请输入标题"
              v-model="ruleForm.bannerTitle"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="ruleForm.isWeb == '1'">
        <el-col :span="12">
          <el-form-item
            class="scale"
            label="WEB配图："
            prop="coverUrl"
            :rules="{
              required: true,
              message: '请上传图片',
            }"
            :show-message="showError"
          >
            <div
              class="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="ruleForm.coverUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer = true"
                ></i>
              </div>
            </div>
            <div class="upload_tip">
              <p>
                WEB端轮播图片（banner图设计模版<a
                  href="https://wlxyoss4t.oss-cn-hangzhou-zwynet-d01-a.internet.cloud.zj.gov.cn/banner/banner%E6%A8%A1%E6%9D%BF.psd"
                  class="download_text"
                  download=""
                  >下载</a
                >）
              </p>
              <p class="img_tip">建议尺寸：2880px*800px（或3:1）</p>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="ruleForm.isWeb == '1'">
          <el-form-item label="背景色值：" prop="backgroundColour">
            <el-input
              placeholder="请输入色值，如 #ffffff"
              v-model="ruleForm.backgroundColour"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        v-if="ruleForm.isApp == '1'"
      >
        <el-col>
          <el-form-item
            class="scale"
            label="APP配图："
            prop="appCoverUrl"
            :rules="{
              required: true,
              message: '请上传图片',
            }"
            :show-message="showError"
          >
            <div
              class="video-output"
              @mouseenter="showCoverTwo = true"
              @mouseleave="showCoverTwo = false"
            >
              <img :src="ruleForm.appCoverUrl" class="avatar" />
              <div v-show="showCoverTwo" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showAppViewer = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteAppCover"
                ></i>
              </div>
            </div>
            <div class="upload_tip">
              <p>APP端轮播图片</p>
              <p class="img_tip">建议尺寸：1029px*390px（或5:2）</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        v-if="ruleForm.isApplet == '1'"
      >
        <el-col>
          <el-form-item
            class="scale"
            label="小程序配图："
            prop="appletCoverUrl"
            :show-message="showError"
          >
            <div
              class="video-output"
              @mouseenter="showCoverMiniApp = true"
              @mouseleave="showCoverMiniApp = false"
            >
              <img :src="ruleForm.appletCoverUrl" class="avatar" />
              <div v-show="showCoverMiniApp" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showMiniAppViewer = true"
                ></i>
    
              </div>
            </div>
            <div class="upload_tip">
              <p>小程序封面</p>
              <p class="img_tip">建议尺寸：1125px*632px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row
        v-if="ruleForm.isPc == '1'"
      >
        <el-col>
          <el-form-item
            class="scale"
            label="PC端配图："
            prop="pcCoverUrl"
            :show-message="showError"
          >
            <div
              class="video-output"
              @mouseenter="showCoverPc = true"
              @mouseleave="showCoverPc = false"
            >
              <img :src="ruleForm.pcCoverUrl" class="avatar" />
              <div v-show="showCoverPc" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showPcViewer = true"
                ></i>
              </div>
            </div>
            <div class="upload_tip">
              <p>PC端封面</p>
              <p class="img_tip">建议尺寸：376px*456px</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="跳转页面：" prop="bannerSkipType">
            <el-radio-group
              v-model="ruleForm.bannerSkipType"
            >
              <el-radio
                v-for="(item, i) in skipList"
                :key="i"
                :label="item.paramKey"
                >{{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="资源："
            prop="resourceId"
            :show-message="showId"
            v-if="ruleForm.bannerSkipType == 1"
          >
            <el-select
              v-model="ruleForm.resourceType"
              placeholder="资源类型"
              style="width: 130px"
            >
              <el-option
                v-for="(item, i) in resouceList"
                :key="i"
                :label="item.paramValue"
                :value="item.paramKey"
              ></el-option>
            </el-select>
            <load-select
              v-if="ruleForm.resourceType == 0"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="videoName"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              placeholder="请选择视频（输入视频名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
            />
            <load-select
              v-if="ruleForm.resourceType == 1"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              placeholder="请选择图书（输入视频名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
            />
            <load-select
              v-if="ruleForm.resourceType == 2"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              placeholder="请选择专题（输入视频名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
            />
            <load-select
              v-if="ruleForm.resourceType == 3"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              placeholder="请选择新闻（输入视频名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
            />
            <load-select
              v-if="ruleForm.resourceType == 4"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="className"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              placeholder="请选择班级（输入视频名称关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
            />
            <load-select
              v-if="ruleForm.resourceType == 5"
              style="width: 330px"
              v-model="ruleForm.resourceId"
              dictLabel="name"
              dictValue="uuid"
              :data="data"
              :page="page"
              :hasMore="more"
              :request="getArticleData"
              placeholder="请选择文章（输入文章关键字以查询）"
              :defaultVal="ruleForm.resourceName"
              :isInit="isInit"
              @change="sourceChange"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.bannerSkipType == 0">
        <el-col :span="12">
          <el-form-item label="链接地址：" prop="detailsLink">
            <el-input
              placeholder="外部链接"
              v-model="ruleForm.detailsLink"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.bannerSkipType == 2">
        <el-col :span="12">
          <el-form-item label="链接地址：" prop="detailsLink">
            <el-select
              v-model="ruleForm.detailsLink"
              placeholder="请选择内链地址"
              style="width: 100%"
            >
              <el-option
                v-for="item in innerLinks"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="item.paramKey"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="ruleForm.bannerSkipType == 3">
        <el-col :span="12">
          <el-form-item
            class="scale"
            label="第三方平台："
            prop="clientOtherPlatformType"
          >
            <el-select
              v-model="ruleForm.clientOtherPlatformType"
              placeholder="请选择跳转的第三方平台"
              style="width: 100%"
            >
              <el-option
                v-for="item in platformTypeData"
                :key="item.paramKey"
                :label="item.paramValue"
                :value="Number(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
     
    </el-form>
    <el-row>
        <el-col>
          <div style="text-align: center">
            <el-button @click="goBack">返回</el-button>
          </div>
        </el-col>
      </el-row>
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[ruleForm.coverUrl]"
    />
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showAppViewer"
      :on-close="closeAppViewer"
      :url-list="[ruleForm.appCoverUrl]"
    />
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showMiniAppViewer"
      :on-close="closeMiniAppViewer"
      :url-list="[ruleForm.appletCoverUrl]"
    />
    <el-image-viewer
      v-if="showPcViewer"
      :on-close="closePcViewer"
      :url-list="[ruleForm.pcCoverUrl]"
    />
  </div>
</template>

<script>
import { getBannerInfo } from "@/api/banner";

import { getSysParamByTypes } from "@/api/sysParam";
import LoadSelect from "@/components/load-select/index.vue";
import rulesFactory from "@/utils/rules";
import { validColor } from "@/utils/rules/validators.js";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { setItem } from "../../../utils/storage";

export default {
  components: { ElImageViewer, LoadSelect },
  data() {
    let validcodeName = (rule, value, callback) => {
      let reg = /^(?:http(s)?:\/\/)?[\w.-]+(?:.[\w.-]+)+[\w\-._~:/?#[\]@!$&'*+,;=.]+$/;
      if (value) {
          this.showUrl = false;
          callback();
      } else {
        this.showUrl = true;
        callback(new Error("请输入链接"));
      }
    };
    return {
      page: 1,
      more: true,
      data: [],
      addTitle: "轮播图详情",
      skipList: [],
      resouceList: [],
      resourceData: [],
      platformTypeData: [], // 第三方平台类型（TYPE：CLIENT_OTHER_PLATFORM_TYPE  1中网院 2八八战略网上展厅）
      innerLinks: [],
      ruleForm: {
        bannerTitle: "",
        backgroundColour: "",
        coverUrl: "",
        bannerSkipType: "0",
        resourceName: "",
        detailsLink: "",
        resourceType: "0",
        resourceId: "",
        appCoverUrl: "",
        appletCoverUrl: "",
        pcCoverUrl: "",
        isApplet: "",
        isApp: "",
        isWeb: "",
        isPc: "",
        clientOtherPlatformType: null,
      },
      rules: {
        bannerTitle: [
          { required: true, message: "请输入标题", trigger: "blur" },
          rulesFactory.size("最多输入50个字", 0, 50),
        ],
        backgroundColour: [
          {
            required: true,
            // message: "请输入色值",
            validator: validColor,
            trigger: "blur",
          },
        ],
        bannerSkipType: [
          { required: true, message: "请选择跳转页面", trigger: "blur" },
        ],
        resourceId: [
          { required: true, message: "请选择资源", trigger: "blur" },
        ],
        appletCoverUrl: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
        pcCoverUrl: [
          { required: true, message: "请上传图片", trigger: "change" }
        ],
        detailsLink: [
          { required: true, validator: validcodeName, trigger: "blur" },
        ],
        clientOtherPlatformType: [{
          required: true, message: "请选择跳转的第三方平台", trigger: "blur"
        }], 
      },
      showError: false,
      showCover: false,
      showCoverTwo: false,
      showCoverMiniApp: false,
      showCoverPc: false,
      showViewer: false,
      showAppViewer: false,
      showMiniAppViewer: false,
      showPcViewer: false,
      errMsg: "",
      showUrl: false,
      showId: false,
      isInit: true,
      publicData: [],
    };
  },
  created() {
    this.getSysParamByTypes([
      "CLIENT_TYPE_BANNER",
      "BANNER_SKIP_TYPE",
      "BANNER_RESOURCE_TYPE",
      "IS_VALID",
      "CLIENT_OTHER_PLATFORM_TYPE",
      "INNER_LINK"
    ]);
      let id = this.$route.query.id;
      getBannerInfo(id).then((res) => {
        if (!res || res.code != 0) return;
        let bannerDetail = res.data;
        this.ruleForm = { ...res.data };
        this.ruleForm.bannerSkipType = bannerDetail.bannerSkipType.toString();
        if (bannerDetail.bannerSkipType == 1) {
          this.ruleForm.resourceId = bannerDetail.resourceId;
          this.ruleForm.resourceType = bannerDetail.resourceType.toString();
          this.ruleForm.resourceName = bannerDetail.resourceName;
        }
        this.$set(this.ruleForm, "detailsLink", String(bannerDetail.detailsLink) || "");
        this.edituuid = res.data.uuid;
      });

  },
  methods: {
    goBack() {
      this.$router.push("/banner");
    },
    
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // this.typeList = res.data["CLIENT_TYPE_BANNER"];
        this.skipList = res.data["BANNER_SKIP_TYPE"];
        this.resouceList = res.data["BANNER_RESOURCE_TYPE"];
        this.publicData = res.data["IS_VALID"] || [];
        this.platformTypeData = res.data["CLIENT_OTHER_PLATFORM_TYPE"] || [];
        this.innerLinks = res.data["INNER_LINK"] || [];
        if (!this.$route.query.id) {
          this.ruleForm.isApp = Number(this.publicData[1].paramKey);
          this.ruleForm.isWeb = Number(this.publicData[1].paramKey);
          this.ruleForm.isApplet = Number(this.publicData[1].paramKey);
          this.ruleForm.isPc = Number(this.publicData[1].paramKey);
        }
      });
    },
    closeViewer() {
      this.showViewer = false;
    },
    closeAppViewer() {
      this.showAppViewer = false;
    },
    closeMiniAppViewer() {
      this.showMiniAppViewer = false;
    },
    closePcViewer() {
      this.showPcViewer = false;
    },
    cancel() {
      this.$router.back();
    },
    
  },
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
$textSize: 14px;
.download_text {
  color: #3a85ff;
  // text-decoration: none;
}
.el-select__tags-text {
  font-size: 14px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

.video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}
</style>
